import React from "react";
import { animateScroll as scroll } from "react-scroll"
import { Button } from 'react-bootstrap';
import styled from "styled-components";
import { FaArrowUp } from 'react-icons/fa'

const Wrappter = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  .btn-primary{
    border-radius: 100%;
    background-color: black;
    border: 3px solid white;
  }
  svg{
    transform: translateY(-1px);
  }
`; 

class PageTopButton extends React.Component {
  scrollToTop = () => {
    scroll.scrollToTop({
      duration: 300,
      delay: 0,
      smooth: 'easeInOutQuart'
    });
  }
  render() {
    return (
      <Wrappter>
        <Button onClick={this.scrollToTop} aria-label="Scroll to top"><FaArrowUp /></Button>
      </Wrappter>
    )
  }
}

export default PageTopButton